export const GalleryImageComponent = ({ url }) => {
  return (
    <div className="gallery_main_image">
      { url ? <img src={url} alt="" />: <span className="dummy_image_card">תמונה</span>}
    </div>
  );
};

export default GalleryImageComponent;
